var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "backorderList"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder')
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "300px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getOrderTypeListSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-tabs', [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "card": "",
      "title": _vm.$t('shipment.backOrderList'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.setOrderType('BO')
      }
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('shipment.backOrderList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 cardlistheader"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('inwardList.table.count')) + " - " + _vm._s(this.totalRows))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('shipment.boItems')) + " ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('shipment.createdOn')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('shipment.updatedOn')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('pincodemapping.updatedBy')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('shipment.stnCreated')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('client.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('client.action')))])])]), _vm._v(" "), _c('tbody', [(_vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listBackorderData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.poid) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalbackorderquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderdate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.updatedon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.updatedby))]), _vm._v(" "), _c('td', [(data.isstncreated == 0) ? _c('p', [_vm._v("No")]) : _vm._e(), _vm._v(" "), (data.isstncreated == 1) ? _c('p', [_vm._v("Yes")]) : _vm._e()]), _vm._v(" "), _c('td', [(data.canceltype == 'M') ? _c('p', {
      attrs: {
        "title": "Manually"
      }
    }, [_vm._v(_vm._s(_vm.$t('shipment.cancelled')))]) : _vm._e(), _vm._v(" "), (data.canceltype == 'A') ? _c('p', {
      attrs: {
        "title": "Automatically"
      }
    }, [_vm._v(_vm._s(_vm.$t('shipment.cancelled')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View Data"
      },
      on: {
        "click": function($event) {
          _vm.showDetail(data.poid, data.iscancelled, data.updatedon, data.updatedby, data.canceltype, 'BO', data.isstncreated, data.clientid)
        }
      }
    })])])
  })], 2)])]), _vm._v(" "), (_vm.pagecount && _vm.listBackorderData.length > 0) ? _c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "total-rows": _vm.pagecount * 10,
      "per-page": 10,
      "aria-controls": "my-table",
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "input": function($event) {
        _vm.getPaginationData(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('shipment.stnOrderList')
    },
    on: {
      "click": function($event) {
        _vm.setOrderType('STN')
      }
    }
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('shipment.stnOrderList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 cardlistheader"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('inwardList.table.count')) + " - " + _vm._s(this.totalRows))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table2"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('shipment.createdOn')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('shipment.updatedOn')) + " ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('pincodemapping.updatedBy')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('shipment.stnCreated')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('client.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('client.action')))])])]), _vm._v(" "), _c('tbody', [(_vm.listSTNOrderData == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSTNOrderData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.poid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderdate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.updatedon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.updatedby))]), _vm._v(" "), _c('td', [(data.isstncreated == 0) ? _c('p', [_vm._v("No")]) : _vm._e(), _vm._v(" "), (data.isstncreated == 1) ? _c('p', [_vm._v("Yes")]) : _vm._e()]), _vm._v(" "), _c('td', [(data.canceltype == 'M') ? _c('p', {
      attrs: {
        "title": "Manually"
      }
    }, [_vm._v(_vm._s(_vm.$t('shipment.cancelled')))]) : _vm._e(), _vm._v(" "), (data.canceltype == 'A') ? _c('p', {
      attrs: {
        "title": "Automatically"
      }
    }, [_vm._v(_vm._s(_vm.$t('shipment.cancelled')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View Data"
      },
      on: {
        "click": function($event) {
          _vm.showDetail(data.poid, data.iscancelled, data.updatedon, data.updatedby, data.canceltype, 'STN', data.isstncreated)
        }
      }
    })])])
  })], 2)])]), _vm._v(" "), (_vm.pagecount && _vm.listSTNOrderData.length > 0) ? _c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "total-rows": _vm.pagecount * 10,
      "per-page": 10,
      "aria-controls": "my-table2",
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "input": function($event) {
        _vm.getPaginationDataStn(_vm.currentPage2)
      }
    },
    model: {
      value: (_vm.currentPage2),
      callback: function($$v) {
        _vm.currentPage2 = $$v
      },
      expression: "currentPage2"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.showDetailModal = false
      }
    },
    model: {
      value: (_vm.showDetailModal),
      callback: function($$v) {
        _vm.showDetailModal = $$v
      },
      expression: "showDetailModal"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.BOmodalHeading) + "[ "), _c('router-link', {
    attrs: {
      "to": {
        name: 'orderdetails',
        params: {
          poid: _vm.currentBODetailID
        }
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.routeLinkModalFalse
    }
  }, [_vm._v(_vm._s(_vm.currentBODetailID))])]), _vm._v(" ]")], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showDetailModal = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "cardlistheader"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isLoader = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.detailLength > 0) ? _c('div', {
    staticClass: "card-headerfrm1"
  }, [(_vm.isdata) ? _c('div', [_c('table', {
    staticClass: "table table-hover tbl"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('stockTransfer.productID')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('reports.clientPID')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.mrp')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.orderQty')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('shipment.updatedOn')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.boDetailData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.orderquantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.rejectedqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.updatedon))])])
  }))]), _vm._v(" "), (_vm.isCancel == 0) ? _c('button', {
    staticClass: "cancelorderbutton form-control",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.addmodal
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.cancelOrder')))]) : _vm._e(), _vm._v(" "), (_vm.STNcreated == 0) ? _c('button', {
    staticClass: "createSTNbutton form-control",
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.createSTN')))]) : _vm._e(), _vm._v(" "), (_vm.isCancel == 1) ? _c('b', [_vm._v("This Order has been cancelled\n                    "), (_vm.canceltype == 'M') ? _c('span', [_vm._v(" by " + _vm._s(_vm.modifiedby))]) : _vm._e(), _vm._v(" "), (_vm.canceltype == 'M') ? _c('span', [_vm._v("on " + _vm._s(_vm.modifiedDate))]) : _vm._e(), _vm._v(" "), (_vm.canceltype == 'A') ? _c('span', [_vm._v(" automatically on " + _vm._s(_vm.modifiedDate))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "sm",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('shipment.cancelOrder')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeaddmodalShow
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('reports.cancelOrderMsg')) + " ?")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primarycancel",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.cancelOrder(_vm.currentBODetailID, _vm.client)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondarycancel",
    staticStyle: {
      "background-color": "gray"
    },
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.closeaddmodalShow
    }
  }, [_vm._v("No")])])])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.detailLength < 1) ? _c('div', {
    staticClass: "card-headerfrm1"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.noDetailFound')))])]) : _vm._e()])])], 1)])], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77e404ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e404ac","hasScoped":true}!./src/views/components/reports/backorderlist/backorderlist.component.html
// module id = 1497
// module chunks = 0